import {ProvidingListApplication} from '../../../shared/models/api';

export const getProfileApplicationsFilterName = (key: string | number, name: string = '') => {
  const modifiedKey = '' + key;
  if (name) {
    return `${name}.${modifiedKey}`;
  }
  return modifiedKey;
};

export const filterApplicationsList =
  (filter: {status: {[key: string]: boolean}; typeApplication: {[key: string]: boolean}}) =>
  (item: ProvidingListApplication) => {
    let isMatch = true;
    if (isMatch && filter?.status && !Object.values(filter.status).every((status) => !status)) {
      isMatch = filter.status[getProfileApplicationsFilterName(item.statusId || '')];
    }
    if (
      isMatch &&
      filter?.typeApplication &&
      !Object.values(filter.typeApplication).every((typeApplication) => !typeApplication)
    ) {
      isMatch = filter.typeApplication[getProfileApplicationsFilterName(item.typeApplicationId || '')];
    }
    return isMatch;
  };
